import * as React from 'react';

const Seo = ({data, title, description, defaultTitle, defaultDescription, noIndex}) => {
  const localeData = data?.locales?.edges?.[0]?.node?.data
  const t = localeData ? JSON.parse(localeData) : null;
  const translatedTitle = t?.[title] ? `${t?.[title]} | Dealfront` : t?.[defaultTitle]
  return <>
    <title>{translatedTitle ? translatedTitle : defaultTitle}</title>
    <meta name="description" content={t?.[description] || defaultDescription} />
    {noIndex ? <meta name="robots" content="noindex" /> : null}
  </>
}

export default Seo;
